import { Component, OnInit } from '@angular/core';
import { Menu } from '../../../../services/nav.service';
import { GlobalAdminComponents } from '../../../../helpers/settings';
import { User } from '../../../../models/user';
import { UserService } from '../../../../services/user.service';

@Component({
	selector: 'app-header-administration',
	templateUrl: './header-administration.component.html',
	styleUrls: ['./header-administration.component.scss']
})
export class HeaderAdministrationComponent implements OnInit {
	public menuItems: Menu[] = [];
	public items: Menu[] = [];
	public text: string = '';

	public bookmarkFlip = false;
	public bookmark = false;

	public open = false;
	public searchResult = false;
	public searchResultEmpty = false;
	public adminRoutes = [];
	public currentUser: Partial<User> = {};

	constructor(public userService: UserService) {}

	ngOnInit(): void {
		this.currentUser = this.userService.getCurrentUser();
		this.getAdministrationRoutes();
	}

	getAdministrationRoutes() {
		if (this.currentUser.roles.some(role => ['Admin', 'SuperAdmin'].includes(role))) {
			this.adminRoutes = GlobalAdminComponents?.filter(configComponent => !configComponent.isChildComponent)
				.map(app => {
					const route = {
						title: app.title,
						name: app.name,
						route: app.route,
						svgIcon: app?.svgIcon ?? null,
						svgImage: app?.svgImage ?? null
					};
					return {
						...route,
						path: `/super-admin/${app.route}/`,
						type: 'link',
						roles: ['Admin', 'SuperAdmin']
					};
				})
				.filter(route => {
					if (route.roles?.some(role => this.currentUser?.roles?.includes(role))) {
						if (
							this.currentUser?.roles?.includes('Admin') &&
							[`/super-admin/account-managers/`, `/super-admin/billings/`].includes(route.path)
						) {
							return false;
						}
						return true;
					}
					return false;
				})
				.map(route => {
					delete route.roles;
					return route;
				});
		}
	}

	ToggleSearch() {
		this.open = !this.open;
		this.removeFix();
	}

	openBookMark() {
		this.bookmark = !this.bookmark;
	}

	flipBookMark() {
		this.bookmarkFlip = !this.bookmarkFlip;
	}

	searchTerm(term: any) {
		term ? this.addFix() : this.removeFix();
		if (!term) {
			this.open = false;
			return (this.menuItems = []);
		}
		const items: any = [];
		term = term.toLowerCase();
		this.items.filter((menuItems: any) => {
			if (!menuItems?.title) return false;
			if (menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link') {
				items.push(menuItems);
			}
			if (!menuItems.children) {
				return false;
			}
			menuItems.children.filter((subItems: any) => {
				if (subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
					subItems.icon = menuItems.icon;
					items.push(subItems);
				}
				if (!subItems.children) {
					return false;
				}
				subItems.children.filter((suSubItems: any) => {
					if (suSubItems.title.toLowerCase().includes(term)) {
						suSubItems.icon = menuItems.icon;
						items.push(suSubItems);
					}
				});
				return;
			});
			this.checkSearchResultEmpty(items);

			return (this.menuItems = items);
		});
		return;
	}

	checkSearchResultEmpty(items: string) {
		if (!items.length) {
			this.searchResultEmpty = true;
		} else {
			this.searchResultEmpty = false;
		}
	}

	addFix() {
		this.searchResult = true;
	}

	removeFix() {
		this.searchResult = false;
		this.text = '';
	}
}
